<template>
    <v-container class="py-0 line-departure-list" :class="{ compact: selectedView === avvikView }">
        <line-departure-set
            v-for="(departure, index) in value"
            :key="index"
            :name="departure.destination"
            :location="departure.originQuayName"
            :items="departure.serviceJourneys"
            :line-number="lineNumber"
            :single-view="departure.singleViewMode"
            :is-today="isToday"
            :selected-view="selectedView"
        />
    </v-container>
</template>

<script lang="ts" setup>
import LineDepartureSet from '@/features/departures/DepartureSet.vue';
import { Views, ViewIndex } from '@/helpers/ViewSwitcher';
import { Departure } from '@/features/departures/Departure';

defineProps<{
    value: Departure[];
    lineNumber: string;
    isToday: boolean;
    selectedView: string;
}>();

const avvikView = Views[ViewIndex.avvik];
</script>

<style lang="scss" scoped>
.compact {
    display: flex;
    justify-content: left;
    flex-wrap: wrap;
}
</style>
